import { ICON_TYPES } from '../constants';

export const ArrowDownIcon = (): JSX.Element => {
  return (
    <svg viewBox="0 0 40 25" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 15.66667L35.3333 0.33333L40 5L20 25L9.53674e-07 5L4.66667 0.33333L20 15.66667Z" />
    </svg>
  );
};

ArrowDownIcon.iconType = ICON_TYPES.ARROW_DOWN;
